require('jquery-mousewheel');
require('malihu-custom-scrollbar-plugin');

export default () => {
  $(".scroll").mCustomScrollbar();
  $(".catalog-block__brand-scroll").mCustomScrollbar();
  $(".popup--questionnaire .select__list").mCustomScrollbar({
    scrollInertia: 0
  });
  if($(window).width() > 1200) {
    $(".js-questionnaire-scroll").mCustomScrollbar();
  }
}



// WEBPACK FOOTER //
// app/scripts/components/scroll.js